import React from 'react';
import { TableRowPlaceholder } from '../tableRowPlaceholder.component';
import { ExpansionPanel, ExpansionPanelDetails,TableCell,Table,TableHead, ExpansionPanelSummary, Typography, TableRow, TableBody} from '@material-ui/core';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SessionNewJoinButtonComponent from '../../join/sessionNewJoinButton.component';
import JoinedFileSessionRow from './joinedFileSessionRow.component'
import { withStyles } from "@material-ui/core/styles";
import _ from 'lodash';
import {findMissingFilesInSession} from '../../../../helpers/findMissingFileInSession.helper'
const styles = () => ({
  root: {
    border: "none",
    boxShadow: "none",
    padding: "0"
  },
  title: {
    margin: "5px 0px"
  },
  table: {
    minWidth: "100%"
  },
  lastTable: {
    minWidth: "100%",
    marginBottom: "50px"
  },
  insidepanel: {
    padding: "0px"
  },
  spacing: {
    margin: "9px 0"
  }
});

const JoinedFiles = ({session, currentFileId,classes}) => {
  const files = _.filter(
    session.files,
    file => file.virtualFile && file.active
  );
  const defaultExpanded = _.some(files,(file) => file.id === currentFileId);
  function renderJoinedTableRows() {

    if (files.length < 1) {
      return <TableRowPlaceholder text="No joined files in this project" colSpan={3}></TableRowPlaceholder>;
    }
    const missingFiles = findMissingFilesInSession(session);
    return files.map(file => {
      let fileMissing = false;
      const missingFileNames = [];
      file.joins.forEach(joinedFile => {
        if( missingFiles.find(missingFile => missingFile === joinedFile.sourceFilename) ) {
          fileMissing = true;
          missingFileNames.push(joinedFile.sourceFilename);
        }
        if(missingFiles.find(missingFile => missingFile === joinedFile.targetFilename)) {
          fileMissing = true;
          missingFileNames.push(joinedFile.targetFilename);
        }

      });
      return (
        <JoinedFileSessionRow
          key={file.id}
          sessionId={session.id}
          row={file}
          rowLastActive={currentFileId === file.id}
          fileMissing={fileMissing}
          missingFiles={_.uniq(missingFileNames)}
        />
      );
    });
  }

  return (
    <ExpansionPanel
      defaultExpanded={defaultExpanded}
      className={classes.root}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.title} variant="subtitle1">
                Joined Files ({files.length})
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.insidepanel}>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
              >
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Filename</TableCell>

                    <TableCell>Date</TableCell>
                    <TableCell colSpan={4}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {renderJoinedTableRows()}
                  <SessionNewJoinButtonComponent session={session} />
                </TableBody>
              </Table>
            </ExpansionPanelDetails>
          </ExpansionPanel>
  )
};


export default withStyles(styles)(JoinedFiles)
